export default __webpack_public_path__ + "fonts/just-sold.svg";